import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

export const Full_ROUTES: Routes = [
  // {
  //   path: 'home',
  //   loadChildren: () =>
  //     import('../../pages/home/home.module').then((m) => m.HomeModule),
  //   canActivate: [AuthGuard],
  // },

  {
    path: 'teams',
    loadChildren: () =>
      import('../../pages/teams/teams.module').then((m) => m.TeamsModule),
    canActivate: [AuthGuard],
  },
];
